// Routes used by Angular router which cannot be used in the dynamic JSON config in the db
export enum RouteReservedPrefix {
  ROOT = '',
  LOGIN = 'login',
  REFERENCING = 'referencing',
  REFEREE = 'referee',
  INTERVIEWS = 'interviews',
  CANCELLED = 'cancelled',
  THANKYOU = 'thankyou',
  INVALID = 'invalid'
}

export const RouteReservedPrefixes = [
  RouteReservedPrefix.ROOT,
  RouteReservedPrefix.LOGIN,
  RouteReservedPrefix.REFERENCING,
  RouteReservedPrefix.REFEREE,
  RouteReservedPrefix.INTERVIEWS,
  RouteReservedPrefix.CANCELLED,
  RouteReservedPrefix.THANKYOU,
  RouteReservedPrefix.INVALID
];

export enum RouteParameters {
  INTERVIEW_ID = 'interviewId'
}
